import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DiscountService from '../../api/services/DiscountService';
import MainPagetitle from '../../layouts/MainPagetitle';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';

const AddDiscount = () => {
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [discountType, setDiscountType] = useState([]);
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      getDiscountType();
    }
    else {
      navigate('/')
    }
  }, []);
  // ----------- get Camper  ------------ //
  const getDiscountType = async () => {
    try {
      let type = await DiscountService.discountType().json();
      setDiscountType(type.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };


  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "discount_type_id": event.target.discount_type_id.value,
        "coupon_code": event.target.coupon_code.value,
        "discount_amount": event.target.discount_amount.value,
        "start_date": event.target.start_date.value,
        "end_date": event.target.end_date.value,
      }
      var startDate = new Date(userData.start_date);
      var endDate = new Date(userData.end_date);

      // Validate if start date is later than end date
      if (startDate > endDate) {
        setError("The Start Date cannot be later than the End Date.");
        return; // Exit the function if the dates are not valid
      }
      else {
        let responseData = await DiscountService.store(userData).json()
        if (responseData.status === true) {

          navigate("/admin/discount");
        }
      }


    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Add Discount" pageTitle={'Add Discount'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Discount</h4>
                </div>
                <div className="card-body">

                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Discount type<span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="discount_type_id">
                        {discountType.map((row, index) =>
                          <option key={index} value={row.id}>{row.discount_type} </option>
                        )}
                      </select>

                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Coupon Code<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='coupon_code' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Discount Amount / Percentage<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='discount_amount' id="val-username" placeholder="" />
                    </div>


                  </div>


                </div>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Validity Time Frame </h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >StartDate</label>
                      <input type="date" className="form-control" name='start_date' id="val-username"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >EndDate</label>
                      <input type="date" className="form-control" name='end_date' id="val-username"
                      />
                    </div>
                    <h5 style={{ color: 'red' }}>{error}</h5>
                  </div>
                </div>
              </div>
            </div>

          </div>


          <div>
            <button type="submit" className="btn btn-primary me-1">Submit</button>
          </div>
        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default AddDiscount;